import React from "react";
import { Grid, TextInput, Text } from "@mantine/core";
import {
  normalizeOrderArFormAccount,
  setOrderIfastAccountNo,
} from "../helpers/arFormUtils";

const SummaryItem = ({ label, value }) => (
  <div>
    <Text size="xs" color="dimmed" mb={2}>
      {label}
    </Text>
    <Text size="sm">{value || "—"}</Text>
  </div>
);

const OrderInvestmentAccount = ({ form, orderSource, readOnly }) => {
  const formAccount = normalizeOrderArFormAccount(form?.values?.arForm);
  const savedOrderAccount = normalizeOrderArFormAccount(orderSource?.arForm);
  const ifastAccountNo = readOnly
    ? savedOrderAccount.ifastAccountNo || formAccount.ifastAccountNo
    : formAccount.ifastAccountNo;

  const handleIfastChange = (event) => {
    setOrderIfastAccountNo(form, event.currentTarget.value);
  };

  return (
    <Grid gutter="md">
      <Grid.Col span={12} md={6}>
        {readOnly ? (
          <SummaryItem
            label="iFAST A/C No. 奕豐戶口號碼"
            value={ifastAccountNo}
          />
        ) : (
          <TextInput
            label="iFAST A/C No. 奕豐戶口號碼"
            value={ifastAccountNo}
            onChange={handleIfastChange}
          />
        )}
      </Grid.Col>
    </Grid>
  );
};

export default OrderInvestmentAccount;
